<template>
  <span>
    <el-tag size="mini" type="success" v-if="item.status === 'DOCUMENTED'">{{ $t('Documented') }}</el-tag>
    <el-tag size="mini" type="primary" v-else-if="item.status === 'VERIFIED'">{{ $t('Verified') }}</el-tag>
    <el-tag size="mini" type="info" v-else-if="item.status === 'PENDING'">{{ $t('Pending') }}</el-tag>
    <el-tag size="mini" type="warning" v-else-if="item.status === 'SUSPENDED'">{{ $t('Suspended') }}</el-tag>
    <el-tag size="mini" type="danger" v-else-if="item.status === 'BLACKLISTED'">{{ $t('Blacklisted') }}</el-tag>
    <el-tag size="mini" type="warning" v-else-if="item.status === 'INACTIVE'">{{ $t('Inactive') }}</el-tag>
    <el-tag size="mini" type="danger" v-else-if="item.status === 'DELETED'">{{ $t('Deleted') }}</el-tag>
    <el-tag size="mini" type="info" v-else>{{ item.status }}</el-tag>
  </span>
</template>

<script>
export default {
  props: {
    item: Object,
  }
}
</script>
